import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Loader } from '../Loader/Loader';
import styles from './FullLoader.styles';

const Container = styled.div`
  ${styles}
`;

export function FullLoader({ visible }) {
  return (
    visible && (
      <Container>
        <Loader size="large" />
      </Container>
    )
  );
}

FullLoader.propTypes = {
  visible: PropTypes.bool
};

FullLoader.defaultProps = {
  visible: false
};
